import { useLogoImage } from '~/shared/components/Logo/hooks/useLogoImage';
import { Logo } from '~/shared/components/Logo/Logo';

import styles from './m190BrandLogo.module.css';

type M190BrandLogoProps = {
	brandNo: string;
};

export const M190BrandLogo = (props: M190BrandLogoProps) => {
	const { image } = useLogoImage({
		brandNo: props.brandNo,
	});

	return (
		<div className={styles.root}>
			<Logo image={image} />
		</div>
	);
};
